import { Disclosure } from 'src/components/ui/Disclosure';
import { formatClock } from 'src/lib/time';
import type { EditorialCriteriaEvidence } from 'src/types/editorial';

/**
 * Art Direction §5 — the default route from a machine assertion back to what produced it.
 * The quotes are testimony and take the reading face.
 */
export function EvidenceDisclosure({
  evidence,
  label = 'Evidencia',
}: {
  evidence: EditorialCriteriaEvidence[];
  label?: string;
}) {
  if (evidence.length === 0) return null;

  return (
    <Disclosure summary={label} count={evidence.length}>
      <ul className="evidence-list">
        {evidence.map((item, index) => (
          <li key={index} className="evidence-list__item">
            <p className="evidence-list__meta mono">
              {item.speaker || 'Hablante desconocido'} · {formatClock(item.timestamp)}
            </p>
            <p className="evidence-list__text reading">“{item.text}”</p>
          </li>
        ))}
      </ul>
    </Disclosure>
  );
}
